import React from "react";
import "./newlaunch2.scss";
import gambarPromo from "../../../asset/flyer-new-launching-wangsa-navya-house.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

const Newlaunch2 = () => {
  const waOpen = () => {
    window.open(
      "https://api.whatsapp.com/send?phone=6287818641024&text=Halo%20Dimas%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20rumah%20ini%20(Newlaunch+Wangsa+Navya+House)%20(https://marketing-kotabaruparahyangan.com/)%20?&fbclid=PAAaa7g9IJ-tB3RyMunLD6w_5ysqP4oI6PA2d9Ml7Isc1_OXjeOiGuAqu7Ap0",
      "_blank",
    );
  };
  return (
    <div className="newlaunc" id="newlaunch2">
      <div id="newpromo2" className="container-produkmtr-newlaunch2">
        <div className="header">
          <div className="h1">New Launching</div>
          <div className="h2">Wangsa Navya House</div>
        </div>
        <div className="container-promo-terbaru">
          <div className="gambar-promo">
            <img src={gambarPromo} alt="promo-discover" />
          </div>
          <div className="container-listpromo-terbaru">
            <div className="listpromo">
              <ul className="list">
                <li>
                  <FontAwesomeIcon icon={faCheckCircle} color="#b0cdf4" />
                  &nbsp;&nbsp;Harga Perdana&nbsp;
                </li>
                <li>
                  <FontAwesomeIcon icon={faCheckCircle} color="#b0cdf4" />
                  &nbsp;&nbsp;DP 1%*&nbsp;
                </li>
                <li>
                  <FontAwesomeIcon icon={faCheckCircle} color="#b0cdf4" />
                  &nbsp;&nbsp;Free Membership Clubhouse Bumi Pacasona 1
                  Year&nbsp;
                </li>
                <li>
                  <FontAwesomeIcon icon={faCheckCircle} color="#b0cdf4" />
                  &nbsp;&nbsp;Free Smart Home System&nbsp;
                </li>
                <li>
                  <FontAwesomeIcon icon={faCheckCircle} color="#b0cdf4" />
                  &nbsp;&nbsp;Free Solar Panel water heater&nbsp;
                </li>
                <li>
                  <FontAwesomeIcon icon={faCheckCircle} color="#b0cdf4" />
                  &nbsp;&nbsp;Free Voucher Yogya 2 juta&nbsp;
                </li>
                <li>
                  <FontAwesomeIcon icon={faCheckCircle} color="#b0cdf4" />
                  &nbsp;&nbsp;Cicilan 9 Jutaan&nbsp;
                </li>
              </ul>
            </div>
            <div className="disclaimer">T&C Apply*</div>
            <div className="button-group">
              <button onClick={waOpen} className="btn-navbar">
                <FontAwesomeIcon icon={faWhatsapp} /> &nbsp; Learn More
              </button>
              <a href="#wangsanavyahouse" className="btn-outline">
                Lihat Rumah
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Newlaunch2;
